// FieldValidationList.jsx
// Created by Claude on 2025-11-23
// Purpose: Display list of validation rules attached to a field

import React from 'react';

const FieldValidationList = ({
  rules = [],
  onEdit,
  onDelete,
  onToggleStatus,
  compact = false
}) => {
  if (rules.length === 0) {
    return (
      <div style={{
        padding: '12px',
        textAlign: 'center',
        backgroundColor: '#F9FAFB',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        color: '#6B7280',
        fontSize: '13px'
      }}>
        No validation rules attached to this field
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {rules.map((rule) => (
        <div
          key={rule.id}
          style={{
            backgroundColor: rule.status === 'ACTIVE' ? '#FFFFFF' : '#F9FAFB',
            border: `1px solid ${rule.status === 'ACTIVE' ? '#E5E7EB' : '#D1D5DB'}`,
            borderRadius: '8px',
            padding: compact ? '10px 12px' : '12px 16px',
            opacity: rule.status === 'ACTIVE' ? 1 : 0.7
          }}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: compact ? '4px' : '8px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
              <h4 style={{
                margin: 0,
                fontSize: compact ? '13px' : '14px',
                fontWeight: '600',
                color: '#111827'
              }}>
                {rule.name}
              </h4>
              <span style={{
                padding: '2px 8px',
                fontSize: '11px',
                fontWeight: '600',
                color: rule.status === 'ACTIVE' ? '#059669' : '#6B7280',
                backgroundColor: rule.status === 'ACTIVE' ? '#D1FAE5' : '#E5E7EB',
                borderRadius: '10px'
              }}>
                {rule.status}
              </span>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '4px' }}>
              {onToggleStatus && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggleStatus(rule);
                  }}
                  title={rule.status === 'ACTIVE' ? 'Disable' : 'Enable'}
                  style={{
                    padding: '4px 8px',
                    fontSize: '12px',
                    backgroundColor: 'transparent',
                    border: '1px solid #D1D5DB',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#6B7280'
                  }}
                >
                  {rule.status === 'ACTIVE' ? '⏸️' : '▶️'}
                </button>
              )}
              
              {onEdit && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(rule);
                  }}
                  title="Edit rule"
                  style={{
                    padding: '4px 8px',
                    fontSize: '12px',
                    backgroundColor: 'transparent',
                    border: '1px solid #3B82F6',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#3B82F6'
                  }}
                >
                  ✏️
                </button>
              )}
              
              {onDelete && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    if (window.confirm(`Remove validation rule "${rule.name}"?`)) {
                      onDelete(rule);
                    }
                  }}
                  title="Remove rule"
                  style={{
                    padding: '4px 8px',
                    fontSize: '12px',
                    backgroundColor: 'transparent',
                    border: '1px solid #FCA5A5',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#DC2626'
                  }}
                >
                  🗑️
                </button>
              )}
            </div>
          </div>

          {/* Description */}
          {rule.description && !compact && (
            <p style={{
              margin: '0 0 8px 0',
              fontSize: '12px',
              color: '#6B7280'
            }}>
              {rule.description}
            </p>
          )}

          {/* Rule Summary */}
          <div style={{
            padding: compact ? '6px 8px' : '8px 10px',
            backgroundColor: '#F9FAFB',
            borderRadius: '6px',
            fontSize: '12px',
            color: '#374151',
            lineHeight: '1.5'
          }}>
            <strong style={{ color: '#059669' }}>IF</strong> {rule.conditions.length} condition{rule.conditions.length > 1 ? 's' : ''} met{' '}
            <strong style={{ color: '#DC2626' }}>THEN</strong>{' '}
            <span style={{ textTransform: 'lowercase' }}>
              {rule.thenAction.replace(/_/g, ' ')}
            </span>
            {rule.thenMessage && (
              <span style={{ fontStyle: 'italic' }}>: "{rule.thenMessage}"</span>
            )}
            {rule.elseAction !== 'ALLOW' && (
              <>
                <br />
                <strong style={{ color: '#3B82F6' }}>ELSE</strong>{' '}
                <span style={{ textTransform: 'lowercase' }}>
                  {rule.elseAction.replace(/_/g, ' ')}
                </span>
                {rule.elseMessage && (
                  <span style={{ fontStyle: 'italic' }}>: "{rule.elseMessage}"</span>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FieldValidationList;


